import { useEffect, useState } from "react";
import { ItemsContainer, NavigationItem } from "@navigation/TopNavigation/TabBar/TabBar";
import { useHostConfig } from "@utils/common/getHostConfig";
import * as Styled from "./CategoryTabBar.styled";

const CategoryTabBar: React.FC<{ activeCategorySlug?: string }> = ({ activeCategorySlug }) => {
  const { categoryOrder } = useHostConfig();
  const [mainCategories, setMainCategories] = useState<Category[]>([]);
  useEffect(() => {
    const onMainCategories = ({ categories }: WebXEventParams["mainCategories"]) => {
      setMainCategories(
        [...categories].sort((a, b) => {
          if (!categoryOrder) return 0;
          const indexA = categoryOrder.indexOf(a.slug);
          const indexB = categoryOrder.indexOf(b.slug);
          if (indexA === indexB) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        })
      );
    };
    window.eventBus.on("mainCategories", onMainCategories, true);

    return () => {
      window.eventBus.off("mainCategories", onMainCategories);
    };
  }, [categoryOrder]);

  return (
    <Styled.SeriesTabBarContainer>
      <Styled.SeriesTabBarContent>
        <ItemsContainer>
          {mainCategories?.map((category) => (
            <NavigationItem
              as={"div"}
              href={undefined as unknown as string}
              key={category.slug}
              data-text={category.title}
              aria-current={activeCategorySlug === category.slug}
              onClick={() => window.eventBus.dispatch("categoryChange", { category })}
            >
              {category.title}
            </NavigationItem>
          ))}
        </ItemsContainer>
      </Styled.SeriesTabBarContent>
    </Styled.SeriesTabBarContainer>
  );
};

export default CategoryTabBar;
